import { FC } from "react";
import { TransactionData, Transactions } from "./transactions";
import { useQuery } from "@apollo/client";
import { Empty, Skeleton } from "antd";
import { CasesSendReportV1TransactionsContainerSendReportCaseV1Document, SendReportCaseV1FinanceDetailsTransactionAdhocTransaction } from "../../../../../../../../generated";
import { ComponentQueryLoader } from "../../../../../../../shared/component-query-loader";
interface TransactionContainerProps {
  caseId: string;
}

export const TransactionsContainer: FC<TransactionContainerProps> = ({caseId}) => {

  const {
    data: financeData,
    loading: financeLoading,
    error: financeError,
  } = useQuery(CasesSendReportV1TransactionsContainerSendReportCaseV1Document, {
    variables: {
      sendReportCaseV1Id: caseId,
    },
  });

  if (financeLoading) {
    return <Skeleton active />;
  }

  if (financeError) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  // calculate total amount
  let totalSentAmount = 0;
  let totalReceivedAmount = 0;
  let totalAmount = 0;
  if (financeData?.sendReportCaseV1?.financeDetails?.transactions) {
    const finance =
      financeData.sendReportCaseV1.financeDetails.transactions ??
      null;
    if (finance) {
      if (finance?.adhocTransactions?.length) {
        totalAmount = finance?.adhocTransactions?.
        filter(transaction => {
          const approval = transaction?.approval;
          const transactionRef = transaction?.transactionReference;
          return !((approval?.isApplicantApprovalRequired === true && approval?.isApplicantApproved !== true) || (transactionRef?.isSuccess === false))
        }).reduce((acc, transaction) => {
          const amount = transaction?.amount;
          if (amount !== undefined && amount !== null) {
            if (amount > 0) {
              totalSentAmount += amount;
            } else if (amount < 0) {
              totalReceivedAmount += Math.abs(amount); // Add to total received if negative
            }
            return acc + amount; // includes both positive and negative
          }
          return acc;
        }, 0);
      }
      if (finance?.submission) {
        const submissionAmount = finance?.submission?.amount ?? 0;
        totalSentAmount += submissionAmount;
      }
    }
  }

  console.log("total amount: ", totalAmount)

  const submissionTransaction: SendReportCaseV1FinanceDetailsTransactionAdhocTransaction | undefined =
    financeData?.sendReportCaseV1?.financeDetails?.transactions?.submission ? {
      amount:
        financeData?.sendReportCaseV1?.financeDetails?.transactions
          ?.submission?.amount ?? undefined,
      reason: 'Request to Send Verification Status Report',
      createdAt:
        financeData?.sendReportCaseV1?.financeDetails?.transactions
          ?.submission?.transactionReference?.completedAt,
      transactionReference: {
        referenceId:
          financeData?.sendReportCaseV1?.financeDetails?.transactions
            ?.submission?.transactionReference?.referenceId,
      },
      id: caseId,
    } : undefined;
  
  const transactionData: TransactionData = financeData?.sendReportCaseV1?.financeDetails ? {
    totalReceived: totalReceivedAmount,
    totalSent: totalSentAmount,
    tableData: [
      ...(financeData?.sendReportCaseV1?.financeDetails?.transactions?.adhocTransactions?.filter(
        (
          item
        ): item is SendReportCaseV1FinanceDetailsTransactionAdhocTransaction => {
          const approval = item?.approval;
          const transactionRef = item?.transactionReference;
          return item !== null && item !== undefined && !((approval?.isApplicantApprovalRequired === true && approval?.isApplicantApproved !== true) || (transactionRef?.isSuccess === false))
        }
      ) || []),
      ...(submissionTransaction?.amount && submissionTransaction.amount > 0 ? [submissionTransaction] : []),
    ],
  } : {
    totalReceived: 0,
    totalSent: 0,
    tableData: [],
  };

  return (
    <ComponentQueryLoader
      loading={false}
      hasData={transactionData !== undefined}
      hasDataComponent={<Transactions data={transactionData} />}
    />
  );
};

